import styled from 'styled-components';

import { IOcAppTheme } from '../../config/ocTheme';

export const CardContainer = styled.div<{ $isClickable: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.color.chatPanelBG};
  border: 1px solid ${({ theme }) => theme.color.chatBorder};
  overflow: hidden;
  cursor: ${({ $isClickable }) => ($isClickable ? 'pointer' : 'default')};
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: ${({ $isClickable }) =>
      $isClickable ? '0 2px 8px rgba(0, 0, 0, 0.1)' : 'none'};
  }
`;

export const OrdinalColumn = styled.div`
  display: flex;
  align-items: start;
  justify-content: center;
  padding: 0.5rem 0;
  background-color: ${({ theme }) => theme.color.betaBadgeBG};
  min-width: 1.5em;
  max-width: 1.5em;
  font-size: ${({ theme }) => theme.font.size.default};
  color: ${({ theme }) => theme.color.chatHeading};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  text-decoration: none;
`;

export const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  padding: 0.5rem;
  flex-grow: 1;
`;

export const Title = styled.h3<{ $isAutomated: boolean }>`
  margin: 0;
  font-size: ${({ theme }) => theme.font.size.default};
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
  color: ${({ theme, $isAutomated }) =>
    $isAutomated ? theme.color.chatHeading : (theme as IOcAppTheme).color.sourcesText};
  line-height: 1.3;
`;

export const BadgeContainer = styled.div`
  margin-top: 0.25rem;
`;

